import React from 'react';
import { Typography } from '@telus-uds/components-web';

import PropTypes from 'prop-types';

const Label = ({ labelName }) => {
  return (
    <div className="main-content-form-headers" style={{ margin: '10px 0' }}>
      <Typography block heading="h4" variant={{ size: 'h4' }}>{labelName}</Typography>
    </div>
  );
};

Label.propTypes = {
  labelName: PropTypes.string.isRequired
};

export default Label;
